import { mode } from "@chakra-ui/theme-tools";
const Card = {
  baseStyle: (props) => ({
    p: "16px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: "12px",
    minWidth: "0px",
    wordWrap: "break-word",
    bg: mode("#ffffff", "navy.800")(props),
    backgroundClip: "border-box",
    boxShadow: mode(
      "0px 4px 20px rgba(0, 0, 0, 0.06)",
      "0px 4px 20px rgba(0, 0, 0, 0.3)"
    )(props),
    border: mode("1px solid", "none")(props),
    borderColor: mode("gray.100", "transparent")(props),
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    _hover: {
      boxShadow: mode(
        "0px 6px 24px rgba(0, 0, 0, 0.08)",
        "0px 6px 24px rgba(0, 0, 0, 0.4)"
      )(props),
    },
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
